// ⚠️ MOCK DATA — placeholder content for the dashboard shell only.
// None of this is wired to Firestore. Replace with live `usage/{yyyymm}` +
// broadcast counters when the Dashboard gains real data (PRD §4.2, P2+).

/** Format a count compactly: 4512 → "4.5K", 100000 → "100K". */
export function fmtCompact(n: number): string {
  if (n < 1000) return String(n);
  const k = n / 1000;
  return (k % 1 === 0 ? k.toFixed(0) : k.toFixed(1)) + 'K';
}

export interface UsageRingData {
  /** i18n key for the ring label. */
  key: string;
  used: number;
  limit: number;
}

// Topbar usage rings: subscribers / messages / AI tokens (PRD §4.2).
export const USAGE_RINGS: UsageRingData[] = [
  { key: 'topbar.subscribers', used: 4512, limit: 5000 },
  { key: 'topbar.messages', used: 3127, limit: 10000 },
  { key: 'topbar.aiTokens', used: 12000, limit: 100000 },
];

export interface StatCardData {
  /** i18n key for the card label. */
  key: string;
  value: string;
  /** Pre-formatted delta token (e.g. "▲ 8%"). */
  delta: string;
  /** Optional i18n key appended after the delta (e.g. "this week"). */
  deltaKey?: string;
}

export const STAT_CARDS: StatCardData[] = [
  { key: 'dash.stat.subscribers', value: '4,512', delta: '▲ 8%', deltaKey: 'dash.delta.week' },
  { key: 'dash.stat.conversations', value: '37', delta: '▲ 12%' },
  { key: 'dash.stat.campaigns', value: '11', delta: '▲ 2' },
  { key: 'dash.stat.openRate', value: '71%', delta: '▲ 4 pts' },
];

export interface CampaignMetric {
  /** Progress fill percentage (0–100). */
  pct: number;
  /** Sub-label, e.g. "177/200" or "—". */
  sub: string;
}

export type CampaignStatus = 'completed' | 'scheduled' | 'sending';

export interface Campaign {
  id: number;
  name: string;
  status: CampaignStatus;
  processed: CampaignMetric;
  delivered: CampaignMetric;
  opened: CampaignMetric;
  unreached: CampaignMetric;
  /** Pre-formatted schedule timestamp for display. */
  scheduledAt: string;
}

export const RECENT_CAMPAIGNS: Campaign[] = [
  {
    id: 1,
    name: 'eid',
    status: 'completed',
    processed: { pct: 100, sub: '200/200' },
    delivered: { pct: 89, sub: '177/200' },
    opened: { pct: 73, sub: '133/182' },
    unreached: { pct: 11, sub: '21/200' },
    scheduledAt: '26 May, 01:11',
  },
  {
    id: 2,
    name: 'eidd',
    status: 'completed',
    processed: { pct: 100, sub: '200/200' },
    delivered: { pct: 98, sub: '195/200' },
    opened: { pct: 70, sub: '136/195' },
    unreached: { pct: 2, sub: '4/200' },
    scheduledAt: '19 May, 12:59',
  },
  {
    id: 3,
    name: 'summer_sale',
    status: 'sending',
    processed: { pct: 64, sub: '1180/1847' },
    delivered: { pct: 58, sub: '1071/1847' },
    opened: { pct: 22, sub: '236/1071' },
    unreached: { pct: 3, sub: '55/1847' },
    scheduledAt: '12 Jun, 10:00',
  },
  {
    id: 4,
    name: 'ramadan_teaser',
    status: 'scheduled',
    processed: { pct: 0, sub: '—' },
    delivered: { pct: 0, sub: '—' },
    opened: { pct: 0, sub: '—' },
    unreached: { pct: 0, sub: '—' },
    scheduledAt: '15 Jun, 10:00',
  },
];
